import { DefaultOptions, QueryClient, QueryClientConfig } from '@tanstack/react-query';

const defaultConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    retryDelay: (retryCount: number): number => 1000 * 2 ** retryCount,
    retry: 5,
  },
  mutations: {},
};

export const queryClient = (config?: QueryClientConfig) =>
  new QueryClient({
    ...config,
    defaultOptions: { ...defaultConfig, ...config?.defaultOptions },
  });
